import * as React from 'react';
import { BorderStyle, Color, Display, Link, withCitrusTheme } from '@gousto-internal/citrus-react';
import { AccordionButton } from '../Accordion/Accordion';

export const DietaryFiltersAccordionButton = withCitrusTheme(AccordionButton, (theme) => ({
  background: theme.color(Color.White),
  outline: 'none',
  boxShadow: 'none',
  color: theme.color(Color.ColdGrey_800),

  '&:hover,&:focus': {
    color: theme.color(Color.Secondary_600),
    boxShadow: `inset 0 0 0 2px ${theme.color(Color.Secondary_600)}`,
  },
}));

export const DietaryFiltersFieldset = withCitrusTheme('fieldset', (theme) => [
  {
    border: 'none',
    paddingBlock: 0,
    paddingInline: 0,
    marginInline: 0,
    display: 'flex',
    flexWrap: 'wrap',
  },
  theme.responsiveSpacing(3, ['columnGap']),
  theme.responsiveSpacing(2, ['rowGap']),
]);

export const DietaryFilterLabelStyles = withCitrusTheme<
  'label',
  React.JSX.IntrinsicElements['label'] & { hasRecipes: boolean; isChecked: boolean | undefined }
>(
  'label',
  (theme, props) => {
    const baseStyles = [
      theme.responsiveSpacing(1, ['paddingTop', 'paddingBottom', 'gap']),
      theme.responsiveSpacing(2, ['paddingLeft', 'paddingRight']),
      theme.border.style(BorderStyle.Solid),
      theme.border.width(0.5),
      {
        backgroundColor: theme.color(Color.ColdGrey_600),
        display: Display.InlineFlex,
        borderRadius: '100px',
        alignItems: 'center',
        cursor: 'pointer',
        ':hover': {
          backgroundColor: theme.color(Color.ColdGrey_800),
        },
        ':focus-within': {
          ...theme.border.color(Color.White),
          boxShadow: `0 0 0 1px ${theme.color(Color.Secondary_600)}`,
        },
      },
    ];

    if (!props.hasRecipes) {
      return [
        baseStyles,
        {
          backgroundColor: theme.color(Color.NeutralGrey_50),
          borderColor: theme.color(Color.NeutralGrey_50),
          color: theme.color(Color.NeutralGrey_200),
          '&:hover': {
            backgroundColor: theme.color(Color.NeutralGrey_100),
          },
        },
      ];
    }

    if (!props.isChecked) {
      return [
        baseStyles,
        {
          backgroundColor: theme.color(Color.White),
          borderColor: theme.color(Color.ColdGrey_600),
          color: theme.color(Color.ColdGrey_600),
          '&:hover': {
            backgroundColor: theme.color(Color.NeutralGrey_50),
          },
        },
      ];
    }

    return baseStyles;
  },
  { omitProps: ['hasRecipes', 'isChecked'] },
);

/**
 * Citrus 'Link' renders a button given no href
 */
export const ResetFilterButton = withCitrusTheme(Link, (theme) => [
  {
    boxShadow: 'none',
    alignItems: 'center',
    '> span': [{ fontFamily: theme.tokens.FontFamilies.book }, theme.responsiveFont([2])],
    '&:focus': { boxShadow: `0 0 0 1px ${theme.color(Color.Secondary_600)}` },
  },
]);
